import { FC } from "react";
import { Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdImport: FC<tSvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 85 97" fill="none" {...props}>
      <Path
        d="m 42.4298,0.00319 c -0.92188,0 -1.6328,0.71094 -1.6328,1.6328 v 72.117 l -15.195,-15.203 c -0.64844,-0.64844 -1.6641,-0.64844 -2.3125,0 -0.6484,0.64844 -0.65234,1.6523 0,2.3047 l 17.98,17.977 c 0.32031,0.31641 0.72656,0.47656 1.1406,0.47656 0.41406,0 0.83594,-0.16406 1.1406,-0.46875 h 0.0078 l 17.977,-17.98 c 0.65234,-0.65234 0.65234,-1.6523 0,-2.3047 -0.65234,-0.65234 -1.6523,-0.65234 -2.3047,0 l -15.195,15.203 V 1.5938 C 44.0436,0.67583 43.37174,0.0079 42.442,0 Z m -40.797,72.648 C 0.73827,72.65119 0,73.37775 0,74.28399 v 20.352 c 0,0.92188 0.69922,1.6172 1.6328,1.6172 h 81.59 c 0.9375,0 1.6328,-0.69141 1.6328,-1.6172 v -20.352 c 0,-0.92188 -0.71094,-1.6328 -1.6328,-1.6328 -0.92186,0 -1.6328,0.71094 -1.6328,1.6328 v 18.73 H 3.254 v -18.73 c 0,-0.92188 -0.72266,-1.6328 -1.6172,-1.6328 z"
        fill="currentColor"
      />
    </Svg>
  );
};

export default PdImport;
